import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";
import { IGetAllProcessosRiscosUseCase } from "../../../presentation/useCases/read/get_all_qualidade_processos_riscos_use_case";
import { ProcessoRiscosLista } from "../../models/processos_riscos_lista";
import { ProcessosRiscosFilter } from "../../models/processos_riscos_filter";


// GetAllQualidadeProcessosRiscosServicoUseCase


export class GetAllQualidadeProcessosRiscosServicoUseCase
  extends BasePaginatedUseCase<ProcessoRiscosLista>
  implements IGetAllProcessosRiscosUseCase {
  constructor(private readonly repository: IQualidadeRepository) {
    super();
  }

  async getAllListagemProcessosRiscos(
    filter: ProcessosRiscosFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    
    const response = await this.repository
      .getAllListagemProcessosRiscos(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
